import React from 'react';
import {colors} from '../styles/colors';
import {translate} from 'react-i18next';
import ArrowBack from 'material-ui-icons/ArrowBack';
import {navigationBack} from '../navigation/NavigationActions';
import {connect} from 'react-redux';
import MyButton from '../components/MyButton';
import InfoSnack from '../utils/InfoSnack';
import design from '../images/design.png';

class InfoScreen extends React.PureComponent {
	constructor() {
		super();

		this.state = {
			bankAccount: null,
		};
	}

	render() {
		const {t} = this.props;
		return (
			<div>
				<InfoSnack onRef={(ref) => (this.infoSnack = ref)} />
				<div className='toolbar'>
					<div
						className='back-arrow'
						onClick={() => this.props.goBack()}
					>
						<ArrowBack />
					</div>

					<h2 style={styles.flex}>{t('info:title')}</h2>
				</div>
				<div style={styles.shareContainer}>
					<h2>{t('info:descriptionTitle')}</h2>
					<p style={{color: colors.text_light}}>
						{t('info:description')}
					</p>
					<img style={styles.previewImg} src={design} alt='design' />

					<div style={styles.button}>
						<MyButton
							style={{marginTop: 35}}
							onPressButton={() => this.props.goBack()}
							title={this.props.t('common:next')}
							color='secondary'
							loading={false}
							variant='raised'
						/>
					</div>
				</div>
			</div>
		);
	}
}

const styles = {
	textInput: {
		paddingTop: 10,
	},
	shareContainer: {
		maxWidth: 512,
		margin: '0 auto',
		paddingTop: 72,
		paddingRight: 16,
		paddingLeft: 16,
	},
	flex: {
		flex: 1,
	},
	previewImg: {
		width: '100%',
		height: 'auto',
	},
	button: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		marginTop: 30,
	},
};

/*const mapStateToProps = (state) => {
    return {
        requestPayoutLoading: state.requestPayoutLoading,
        requestPayoutSuccess: state.requestPayoutSuccess,
        loadingRequestPayoutFailed: state.loadingRequestPayoutFailed,
        initialOrder: state.initialOrder,
        period: state.period,
    };
};*/

const mapDispatchToProps = (dispatch) => {
	return {
		goBack: () => dispatch(navigationBack()),
	};
};

export default connect(
	null,
	mapDispatchToProps
)(translate(['info', 'common'])(InfoScreen));



// WEBPACK FOOTER //
// ./src/info/InfoScreen.js